<!-- Spinner -->

<!-- Content -->
@if ((trainingSharedFacade.currentSelectedSlideQuestions$ | async) | sortBy_shared:'asc':'order'; as questions) {
  @if (questions.length > 0) {
    @for (question of questions; track question; let i = $index) {
      <div class="question-container pt-0"
        [ngStyle]="{'order': question.order}">
        @if ((trainingSharedFacade.currentSlideResultByQuestionId$(question.id) | async); as trainingResult) {
          @switch (question.type) {
            @case (FlatModels.QuestionEntityModels.QuestionType.enum.MappingQuestion) {
              <medsurf-quiz-mapping-question
                [index]="i"
                [question]="question"
                [trainingResult]="trainingResult"
                #questionComponent>
              </medsurf-quiz-mapping-question>
            }
            @case (FlatModels.QuestionEntityModels.QuestionType.enum.LongListQuestion) {
              <medsurf-quiz-single-choice-question
                [index]="i"
                [question]="question"
                [trainingResult]="trainingResult"
                #questionComponent>
              </medsurf-quiz-single-choice-question>
            }
            @case (FlatModels.QuestionEntityModels.QuestionType.enum.SingleChoiceQuestion) {
              <medsurf-quiz-single-choice-question
                [index]="i"
                [question]="question"
                [trainingResult]="trainingResult"
                #questionComponent>
              </medsurf-quiz-single-choice-question>
            }
            @case (FlatModels.QuestionEntityModels.QuestionType.enum.TrueFalseQuestion) {
              <medsurf-quiz-k-prim-question
                [index]="i"
                [question]="question"
                [trainingResult]="trainingResult"
                #questionComponent>
              </medsurf-quiz-k-prim-question>
            }
            @case (FlatModels.QuestionEntityModels.QuestionType.enum.KprimeQuestion) {
              <medsurf-quiz-k-prim-question
                [index]="i"
                [question]="question"
                [trainingResult]="trainingResult"
                #questionComponent>
              </medsurf-quiz-k-prim-question>
            }
            @case (FlatModels.QuestionEntityModels.QuestionType.enum.FreeTextQuestion) {
              <medsurf-quiz-freetext-question
                [index]="i"
                [question]="question"
                [trainingResult]="trainingResult"
                #questionComponent>
              </medsurf-quiz-freetext-question>
            }
            @case (FlatModels.QuestionEntityModels.QuestionType.enum.IndicationQuestion) {
              <medsurf-quiz-indication-question
                [index]="i"
                [question]="question"
                [trainingResult]="trainingResult"
                #questionComponent>
              </medsurf-quiz-indication-question>
            }
          }
        }
      </div>
    }
    @if (questions.length > 1 && (menuSharedFacade.showPrint$ | async) === false) {
      @if ({showFeedback: (trainingSharedFacade.currentSlideResultShowFeedback$ | async), showExplanation: (trainingSharedFacade.currentSlideResultShowExplanation$ | async), trainingPage: (trainingSharedFacade.currentSelectedSlidePage$ | async)}; as trainingData) {
        <div class="d-flex order-1000" role="group">
          <!-- Show Answer -->
          @if (trainingData.showFeedback === false) {
            <button type="button"
              class="mdsf-btn mdsf-btn-primary"
              role="button"
              (click)="setShowFeedback(trainingData.trainingPage)"
              translate="check_answer_all">
            </button>
          }
          @if (trainingData.showFeedback) {
            <button type="button"
              class="mdsf-btn"
              role="button"
              disabled
              >
              {{ 'check_answer_all_done' | translate }}  <i class="fa fa-fw fa-times"></i>
            </button>
          }
          <!-- Show Feedback -->
          @if (trainingData.showFeedback && trainingData.showExplanation === false) {
            <button type="button"
              class="mdsf-btn ml-3 mdsf-btn-primary"
              role="button"
              (click)="toggleShowExplanation()"
              translate="show_explanation_all">
            </button>
          }
          @if (trainingData.showFeedback && trainingData.showExplanation) {
            <button type="button"
              class="mdsf-btn ml-3"
              role="button"
              (click)="toggleShowExplanation()">
              {{ 'show_explanation_all_done' | translate }}  <i class="fa fa-fw fa-times"></i>
            </button>
          }
        </div>
      }
    }
  }
} @else {
  <div class="d-flex justify-content-center m-2">
    <div class="spinner-border"></div>
  </div>
}
